import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFilm, FiTv, FiLayers } = FiIcons;

const Services = () => {
  const projects = [
    {
      icon: FiFilm,
      title: 'Tinman',
      description: 'A dedicated surgeon puzzles with the idea that a world wide virus is man made.',
      tag: 'Sci-Fi Feature',
      path: '/tinman'
    },
    {
      icon: FiLayers,
      title: 'The Playground',
      description: 'Where innocence meets terror. A haunting psychological thriller that explores the dark, forgotten echoes of childhood memories.',
      tag: 'Horror Thriller',
      path: '/playground'
    },
    {
      icon: FiTv,
      title: 'Truth & Fairytales',
      description: 'A raw, visceral deconstruction of grief. Follow a psychologist\'s journey through modern myths in a gritty, realistic anthology series.',
      tag: 'Dramatic Series',
      path: '/fairytales'
    }
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          className="text-center mb-16"
        >
          <span className="text-accent-orange font-bold tracking-widest uppercase text-[10px] italic">Latest Works</span>
          <h2 className="text-5xl font-serif font-bold text-black mt-4 mb-6 uppercase tracking-tight">Which projects are featured?</h2>
          <div className="w-20 h-1 bg-accent-orange mx-auto mb-6"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((item, index) => (
            <Link key={item.title} to={item.path} className="block group">
              <motion.div
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="p-10 rounded-[40px] bg-beige-light border border-beige group-hover:bg-black group-hover:border-black transition-all duration-500 group-hover:shadow-2xl h-full flex flex-col"
              >
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-8 group-hover:bg-accent-orange transition-all duration-500 group-hover:rotate-12 group-hover:scale-110">
                  <SafeIcon icon={item.icon} className="w-8 h-8 text-black group-hover:text-white transition-colors duration-500" />
                </div>
                <span className="text-accent-orange font-bold text-[10px] tracking-[0.2em] uppercase mb-2 block">{item.tag}</span>
                <h3 className="text-3xl font-serif font-bold text-black mb-4 group-hover:text-white transition-colors duration-500">{item.title}</h3>
                <p className="text-black/60 mb-8 leading-relaxed group-hover:text-white/70 transition-colors duration-500 font-medium flex-grow">{item.description}</p>
                <div className="pt-6 border-t border-beige group-hover:border-white/10 mt-auto">
                  <span className="text-[10px] font-bold uppercase tracking-widest text-black group-hover:text-accent-orange transition-colors">Explore Project →</span>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;